import { isOnMobileDevice } from 'js/src/libs/mobile-check';
import { getServiceLevel, hasFeatureEnabled, ServiceLevel } from 'js/src/libs/server-utils';
import type { DAMConfig } from 'js/src/typings/global';
import Cookies from 'js-cookie';

const Flags = {
    canUseStaffControls: (): boolean => {
        return hasFeatureEnabled('staff_controls');
    },
    canSeeDamTab: (): boolean => {
        if (!window.SERVER?.USER?.dam_configs) {
            return false;
        }
        const damConfigs = window.SERVER.USER.dam_configs;
        return damConfigs.some((damConfig: DAMConfig) => {
            if (damConfig.require_connection && damConfig.is_connected) {
                return true;
            }
            if (!damConfig.require_connection) {
                return true;
            }
            return false;
        });
    },
    canSeeAiContextSettings: () => {
        return hasFeatureEnabled('ai_context_settings');
    },
    canUseChat: () => {
        return hasFeatureEnabled('chat');
    },
    chatTabDeveloperToolsEnabled: () => {
        return hasFeatureEnabled('sketch_show_dev_details');
    },
    chartsTabDeveloperToolsEnabled: () => {
        return Cookies.get('charts_tab_developer_tools') === 'true';
    },
    canUseScreenRecording: () => {
        return window.SERVER?.USER?.capabilities?.screen_recording ?? true;
    },
    canUseBlueprintAgent: () => {
        return hasFeatureEnabled('blueprint_agent');
    },
    canUseImproveMediaAgent: () => {
        return process.env.NODE_ENV !== 'test';
    },
    canUseAgentFamily: () => {
        if (getServiceLevel() === ServiceLevel.HIGH) {
            return Flags.canUseImproveMediaAgent() || Flags.canUseBlueprintAgent();
        } else {
            return false;
        }
    },
    canUseMediaAge: () => {
        return hasFeatureEnabled('enrich_media_age');
    },
    canUseMorphTransitions: () => {
        return hasFeatureEnabled('morph_transitions');
    },
    isDefaultSketchEnabled: () => {
        return hasFeatureEnabled('default_sketch') || isOnMobileDevice();
    },
    canUseChartGeneration: () => {
        return hasFeatureEnabled('chart_generation');
    },
    canUseChartAsset: () => {
        return hasFeatureEnabled('chart_asset');
    },
    canUseTextInElementsTab: () => {
        return hasFeatureEnabled('text_in_elements_tab');
    },
    canUseSoundEffects: () => {
        return hasFeatureEnabled('sound_effects');
    },
    canUseTransitionSFX: () => {
        return hasFeatureEnabled('sound_effects_transition');
    },
    hideGifs: () => {
        return hasFeatureEnabled('hide_gifs');
    },
    canUseAnimatedExplainerVideos: () => {
        return hasFeatureEnabled('animated_explainer_video') && window.SERVER.USER.plan_price > 0;
    },
    canSeeGenXOptin: () => {
        return hasFeatureEnabled('genx_show_optin');
    },
    canSeeBasicVoiceFilters: () => {
        return hasFeatureEnabled('basic_voice_filters');
    },
};

export default Flags;
